import React from 'react';

import { MarketplaceCard } from '@pkg/components';
import { AddToLiquidIdCard } from '@pkg/components/Common/CardTile/AddToLiquidIdCard';
import { type Collectible } from '@pkg/graphql/codegen/graphql';

import { LoadingGridAnimation } from '@app/pages/ProfilePage/components';
import { useNFTsFiltersStore } from '@app/store/zustand';

import { CardWrapper, HiddenBadge, Wrapper } from './GridView.style';

export interface GridViewProps {
    nftEntries?: Collectible[];
    isLoading?: boolean;
    isOwner?: boolean;
    isNFTManager?: boolean;
}

export function GridView({ nftEntries = [], isLoading = false, isOwner = false, isNFTManager = false }: GridViewProps) {
    const { availableFilters } = useNFTsFiltersStore();

    const showHiddenNfts = availableFilters.hasSomeValue('status', 'hidden');

    const itemsMarkup = nftEntries?.map((item: Collectible) => {
        if (isNFTManager) {
            return (
                <CardWrapper key={`${item?.id}-${item?.owner?.address}`}>
                    <AddToLiquidIdCard item={item} cardSize="small" isOwner={isOwner} />
                </CardWrapper>
            );
        }

        return (
            <CardWrapper key={`${item?.id}-${item?.owner?.address}`}>
                {item?.hidden && !showHiddenNfts ? <HiddenBadge>Hidden</HiddenBadge> : null}
                <MarketplaceCard item={item} cardSize="small" isOwner={isOwner} />
            </CardWrapper>
        );
    });

    return (
        <Wrapper>
            {itemsMarkup}
            {isLoading ? <LoadingGridAnimation /> : null}
        </Wrapper>
    );
}
